export default __webpack_public_path__ + "static/media/Intersec-Dubai-Giasco-1.2bbf04a4.jpg";